import { call, put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_INVENTORY_PREFERENCE_SUCCESS,
    GET_INVENTORY_PREFERENCE_FAILURE,
} from '../actions';

export default function* getInventoryPreferenceSaga() {
    const baseSiteId = localStorage.getItem('baseSiteId') || 'defaultSite';
    const url = `/occ/v2/${baseSiteId}/inventory/getInventoryPreference`;

    try {
        const { data } = yield call(axios.get, url);
        yield put({
            type: GET_INVENTORY_PREFERENCE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({
            type: GET_INVENTORY_PREFERENCE_FAILURE,
            payload: errorHandler(error?.response?.status || '503'),
        });
    }
}
